export default __webpack_public_path__ + "static/media/amex.03e8d50c.svg";